<template>
  <div
    :id="modalId"
    :class="classes"
    :style="this.styles"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Novo Produto</h5>
          <button type="button" class="close" @click="hide" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit.prevent="create" class="form-horizontal">
          <div class="modal-body">
            <div class="form-body">
              <div class="form-group row">
                <label class="control-label text-right col-md-4 text-left-m"
                  >{{$tc('generic-str.name', 1)}}</label
                >
                <div class="col-md-6">
                  <input v-model="form.name" type="text" class="form-control" />
                </div>
              </div>
              <div class="form-group row">
                <label class="control-label text-right col-md-4 text-left-m"
                  >{{$t('generic-str.type')}}</label
                >
                <div class="col-md-6">
                  <select-input
                    v-model="form.type"
                    :options="types"
                    :clearable="false"
                    @input="changeType"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="control-label text-right col-md-4 text-left-m"
                  >{{$t('customer-component.route')}}</label
                >
                <div class="col-md-6">
                  <select-input
                    v-if="providers.length"
                    v-model="form.provider_id"
                    label="alias"
                    :reduce="(provider) => provider.id"
                    :options="providers"
                    :clearable="false"
                  />
                  <div v-else class="preloader pl-xxs pls-primary">
                    <svg class="pl-circular" viewBox="25 25 50 50">
                      <circle class="plc-path" cx="50" cy="50" r="20"></circle>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="hide">
              {{$t('generic-str.cancel')}}
            </button>
            <button
              :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }"
              :disabled="isSending"
              type="submit"
              class="btn btn-primary"
            >
              {{$t('generic-str.create')}}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ProductService from '@/services/admin/product.service';
import ProviderService from '@/services/admin/provider.service';
import Modal from '@/mixins/Modal';
import SelectInput from '@/components/SelectInput.vue';

export default {
  components: {
    SelectInput,
  },
  mixins: [Modal],
  props: ['id'],
  data() {
    return {
      types: JSON.parse(process.env.VUE_APP_TYPES),
      routes: [],
      providers: [],
      form: {
        name: '',
        type: '',
        provider_id: '',
      },
      isSending: false,
    };
  },
  created() {
    this.form.type = this.types[0];
    this.changeType();
  },
  methods: {
    changeType() {
      this.providers = [];
      this.form.provider_id = '';
      this.fetchProviders();
    },
    fetchProviders() {
      ProviderService.getProviders({
        type: this.form.type,
      }).then(
        (response) => {
          this.providers = response;
        },
        (error) => {
          this.content = error;
        },
      );
    },
    create() {
      this.isSending = true;
      ProductService.createProduct(this.form).then(
        () => {
          this.hide();
          this.$toast.show({
            title: this.$t('generic-str.success'),
            content: this.$t('customer-component.product-created'),
            type: 'success',
          });
          this.$emit('sent');
          this.isSending = false;
        },
        (error) => {
          this.$toast.show({
            title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
            content: error.message,
            type: 'danger',
          });
          this.isSending = false;
        },
      );
    },
  },
};
</script>
